import template from './ticketSummary.html';
import controller from './ticketSummary.controller';

export const ticketSummaryComponent = {
  restrict: 'E',
  bindings: {
    'ticket': '<'
  },
  template,
  controller,
  controllerAs: 'vm'
};
